import { useEffect, useState } from "react";
import {
  clearPayoutsAuthCache,
  ensurePayoutsAccessToken,
} from "../Dashboard/Payouts/api/payoutApiClient";
import {
  PAYOUTS_LOCAL_SHELL_KEY,
  isPayoutsLocalShellEnabled,
} from "../../utils/payoutLocalShell";

function TrusteeLogin() {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const jwtToken = params.get("token") || "";
    if (!jwtToken) {
      setError("Missing token in URL. Use /admin?token=...");
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        localStorage.setItem("merchantToken", jwtToken);
        if (isPayoutsLocalShellEnabled()) {
          localStorage.setItem(PAYOUTS_LOCAL_SHELL_KEY, "1");
          clearPayoutsAuthCache();
          try {
            await ensurePayoutsAccessToken();
          } catch (err) {
            // Still enter the app shell; payouts calls will retry exchange.
            console.warn("Payouts auth exchange failed on /admin login", err);
          }
          if (!cancelled) {
            window.location.replace("/payouts/dashboard");
          }
          return;
        }
        if (!cancelled) {
          window.location.replace("/");
        }
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : "Login failed");
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center p-8 text-center">
        <div>
          <h1 className="text-lg font-semibold text-[#1B163B]">Admin login failed</h1>
          <p className="mt-2 text-sm text-[#505E8E]">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center p-8 text-sm text-[#505E8E]">
      Signing you in…
    </div>
  );
}

export default TrusteeLogin;
